import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  experience: {
    id: 'Descriptions.Experience',
    defaultMessage:
      'Each quest must be engaging for the learner, incorporate varying learning strategies, and reflect the Quest Forward vision for quest design.'
  },
  subject: {
    id: 'Descriptions.Subject',
    defaultMessage:
      'Each quest must fulfill criteria for subject matter, including adequate coverage of applicable sub-topics and interdisciplinary content.'
  },
  copy: {
    id: 'Descriptions.Copy',
    defaultMessage:
      'Each quest must fulfill criteria for copy, such as proper use of grammar, spelling, and punctuation.'
  }
})



// WEBPACK FOOTER //
// ./src/utils/messages/descriptions.js